import { idToken } from '../firebase';

const BACKEND = ((import.meta.env.VITE_BACKEND_URL as string | undefined) || '').replace(/\/$/, '');

/**
 * One line of what somebody thinks, sent from wherever they were standing when
 * they thought it (routes/kindling.ts). `where` is the screen, so a pile of
 * these can be read by place rather than only by time.
 */
export async function sendFeedback(text: string, where: string, extra?: { day?: number; challengeId?: string }): Promise<void> {
  const token = await idToken();
  const res = await fetch(`${BACKEND}/api/kindling/feedback`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
    body: JSON.stringify({ text: text.trim(), where, ...extra }),
  });
  if (!res.ok) throw new Error(`feedback failed (${res.status})`);
}
